import React, { useState } from "react";
import { MdClose, MdSave, MdPersonAdd, MdWarning } from "react-icons/md";
import { authAPI } from "services/api";

const StaffAddModal = ({ isOpen, onClose }) => {
    // --- STATELER (StaffAdd.js'den Birebir Work-Logic) ---
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
        password: "",
        password_confirmation: "",
        role: "staff",
        birth_date: "",
        tag: "",
    });
    const [countryCode, setCountryCode] = useState("+90");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    // --- İŞLEYİCİLER ---
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        try {
            // CoreUI StaffAdd.js içindeki birebir aynı payload yapısı
            await authAPI.register({
                name: formData.firstName,
                surname: formData.lastName,
                email: formData.email,
                phone: `${countryCode}${formData.phone.replace(/\s+/g, '')}`, // Dilersen `${countryCode}${formData.phone}` olarak da birleştirebilirsin
                password: formData.password,
                password_confirmation: formData.password_confirmation,
                role: formData.role,
                birth_date: formData.birth_date,
                tag: formData.tag
            });
            onClose(); // Başarılıysa modalı kapat ve listeyi yenilemeye tetik at
        } catch (err) {
            setError(err.response?.data?.message || "Personel eklenirken bir hata oluştu.");
        } finally {
            setLoading(false);
        }
    };

    // Modal açık değilse render etme
    if (!isOpen) return null;

    return (
        // ARKAPLAN (BUZLU CAM)
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-navy-900/40 backdrop-blur-sm p-4 transition-all">

            {/* MODAL KARTI */}
            <div className="relative w-full max-w-3xl bg-white dark:bg-navy-800 rounded-[24px] shadow-2xl overflow-hidden flex flex-col max-h-[90vh]">

                {/* HEADER */}
                <div className="flex-none flex items-center justify-between p-6 border-b border-gray-100 dark:border-white/10">
                    <div className="flex items-center gap-4">
                        <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-brand-500 text-white shadow-lg shadow-brand-500/30">
                            <MdPersonAdd className="text-2xl" />
                        </div>
                        <div>
                            <h3 className="text-xl font-bold text-navy-700 dark:text-white">Yeni Personel Ekle</h3>
                            <p className="text-sm font-medium text-gray-500 dark:text-gray-400 mt-0.5">Sisteme yeni bir kullanıcı tanımlayın</p>
                        </div>
                    </div>
                    <button
                        onClick={onClose}
                        className="flex h-10 w-10 items-center justify-center rounded-full text-gray-500 hover:bg-gray-100 dark:hover:bg-navy-700 dark:text-gray-400 transition-all"
                    >
                        <MdClose className="text-2xl" />
                    </button>
                </div>

                {/* BODY (KAYDIRILABİLİR FORM) */}
                <div className="flex-1 overflow-y-auto custom-modal-scroll p-6">

                    {error && (
                        <div className="mb-6 flex items-center gap-3 rounded-xl bg-red-50 p-4 text-red-600 dark:bg-red-500/10 dark:text-red-400 border border-red-100 dark:border-red-500/20">
                            <MdWarning className="text-xl flex-none" />
                            <p className="text-sm font-bold">{error}</p>
                        </div>
                    )}

                    <form id="addStaffForm" onSubmit={handleSubmit} className="flex flex-col gap-5">

                        {/* 1. SATIR: İsim / Soyisim */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                            <div>
                                <label className="text-sm font-bold text-navy-700 dark:text-white ml-1 mb-2 block">Ad *</label>
                                <input
                                    required
                                    name="firstName"
                                    value={formData.firstName}
                                    onChange={handleChange}
                                    className="flex h-12 w-full items-center justify-center rounded-xl border border-gray-200 bg-white/0 p-3 text-sm font-medium text-navy-700 outline-none focus:border-brand-500 dark:border-white/10 dark:text-white dark:focus:border-brand-400 transition-all"
                                    placeholder="Örn: Ahmet"
                                />
                            </div>
                            <div>
                                <label className="text-sm font-bold text-navy-700 dark:text-white ml-1 mb-2 block">Soyad *</label>
                                <input
                                    required
                                    name="lastName"
                                    value={formData.lastName}
                                    onChange={handleChange}
                                    className="flex h-12 w-full items-center justify-center rounded-xl border border-gray-200 bg-white/0 p-3 text-sm font-medium text-navy-700 outline-none focus:border-brand-500 dark:border-white/10 dark:text-white dark:focus:border-brand-400 transition-all"
                                    placeholder="Örn: Yılmaz"
                                />
                            </div>
                        </div>

                        {/* 2. SATIR: Telefon / E-Posta */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                            <div>
                                <label className="text-sm font-bold text-navy-700 dark:text-white ml-1 mb-2 block">Telefon *</label>
                                <div className="flex items-center gap-2">
                                    <select
                                        value={countryCode}
                                        onChange={(e) => setCountryCode(e.target.value)}
                                        className="flex h-12 w-24 items-center justify-center rounded-xl border border-gray-200 bg-gray-50 p-3 text-sm font-bold text-navy-700 outline-none dark:border-white/10 dark:bg-navy-900 dark:text-white transition-all"
                                    >
                                        <option value="+90">TR (+90)</option>
                                    </select>
                                    <input
                                        required
                                        name="phone"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        className="flex h-12 flex-1 items-center justify-center rounded-xl border border-gray-200 bg-white/0 p-3 text-sm font-medium text-navy-700 outline-none focus:border-brand-500 dark:border-white/10 dark:text-white dark:focus:border-brand-400 transition-all"
                                        placeholder="5XX XXX XX XX"
                                    />
                                </div>
                            </div>
                            <div>
                                <label className="text-sm font-bold text-navy-700 dark:text-white ml-1 mb-2 block">E-Posta *</label>
                                <input
                                    required
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    className="flex h-12 w-full items-center justify-center rounded-xl border border-gray-200 bg-white/0 p-3 text-sm font-medium text-navy-700 outline-none focus:border-brand-500 dark:border-white/10 dark:text-white dark:focus:border-brand-400 transition-all"
                                    placeholder="ornek@vireliosoft.com"
                                />
                            </div>
                        </div>

                        {/* 3. SATIR: Şifreler */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                            <div>
                                <label className="text-sm font-bold text-navy-700 dark:text-white ml-1 mb-2 block">Şifre *</label>
                                <input
                                    required
                                    type="password"
                                    name="password"
                                    value={formData.password}
                                    onChange={handleChange}
                                    className="flex h-12 w-full items-center justify-center rounded-xl border border-gray-200 bg-white/0 p-3 text-sm font-medium text-navy-700 outline-none focus:border-brand-500 dark:border-white/10 dark:text-white dark:focus:border-brand-400 transition-all"
                                    placeholder="En az 6 karakter"
                                />
                            </div>
                            <div>
                                <label className="text-sm font-bold text-navy-700 dark:text-white ml-1 mb-2 block">Şifre Tekrar *</label>
                                <input
                                    required
                                    type="password"
                                    name="password_confirmation"
                                    value={formData.password_confirmation}
                                    onChange={handleChange}
                                    className="flex h-12 w-full items-center justify-center rounded-xl border border-gray-200 bg-white/0 p-3 text-sm font-medium text-navy-700 outline-none focus:border-brand-500 dark:border-white/10 dark:text-white dark:focus:border-brand-400 transition-all"
                                    placeholder="Şifreyi doğrulayın"
                                />
                            </div>
                        </div>

                        {/* 4. SATIR: Rol, Doğum Tarihi, Etiket */}
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                            <div>
                                <label className="text-sm font-bold text-navy-700 dark:text-white ml-1 mb-2 block">Rol</label>
                                <select
                                    name="role"
                                    value={formData.role}
                                    onChange={handleChange}
                                    className="flex h-12 w-full items-center justify-center rounded-xl border border-gray-200 bg-white/0 p-3 text-sm font-bold text-navy-700 outline-none focus:border-brand-500 dark:border-white/10 dark:bg-navy-900 dark:text-white transition-all appearance-none"
                                >
                                    <option value="staff">Personel</option>
                                    <option value="admin">Yönetici</option>
                                </select>
                            </div>
                            <div>
                                <label className="text-sm font-bold text-navy-700 dark:text-white ml-1 mb-2 block">Doğum Tarihi</label>
                                <input
                                    type="date"
                                    name="birth_date"
                                    value={formData.birth_date}
                                    onChange={handleChange}
                                    className="flex h-12 w-full items-center justify-center rounded-xl border border-gray-200 bg-white/0 p-3 text-sm font-medium text-navy-700 outline-none focus:border-brand-500 dark:border-white/10 dark:text-white dark:focus:border-brand-400 transition-all"
                                />
                            </div>
                            <div>
                                <label className="text-sm font-bold text-navy-700 dark:text-white ml-1 mb-2 block">Etiket (Uzmanlık)</label>
                                <input
                                    name="tag"
                                    value={formData.tag}
                                    onChange={handleChange}
                                    className="flex h-12 w-full items-center justify-center rounded-xl border border-gray-200 bg-white/0 p-3 text-sm font-medium text-navy-700 outline-none focus:border-brand-500 dark:border-white/10 dark:text-white dark:focus:border-brand-400 transition-all"
                                    placeholder="Örn: Kuaför, Kasa"
                                />
                            </div>
                        </div>

                    </form>
                </div>

                {/* FOOTER (BUTONLAR) */}
                <div className="flex-none flex items-center justify-end gap-3 p-6 border-t border-gray-100 dark:border-white/10 bg-gray-50 dark:bg-navy-800/50">
                    <button
                        type="button"
                        onClick={onClose}
                        className="flex h-12 items-center justify-center rounded-xl px-6 text-sm font-bold text-gray-600 hover:bg-gray-200 dark:text-gray-300 dark:hover:bg-navy-700 transition-all"
                    >
                        İptal Et
                    </button>
                    <button
                        type="submit"
                        form="addStaffForm"
                        disabled={loading}
                        className="flex h-12 items-center justify-center gap-2 rounded-xl bg-brand-500 px-8 text-sm font-bold text-white shadow-lg shadow-brand-500/30 hover:bg-brand-600 disabled:opacity-70 disabled:cursor-not-allowed transition-all active:scale-95"
                    >
                        {loading ? (
                            <div className="h-5 w-5 animate-spin rounded-full border-2 border-white border-t-transparent" />
                        ) : (
                            <><MdSave className="text-lg" /> Kaydet ve Ekle</>
                        )}
                    </button>
                </div>

            </div>

            {/* İç Scrollbar Tasarımı (Custom Scrollbar) */}
            <style jsx="true">{`
        .custom-modal-scroll::-webkit-scrollbar { width: 6px; }
        .custom-modal-scroll::-webkit-scrollbar-track { background: transparent; }
        .custom-modal-scroll::-webkit-scrollbar-thumb { background: rgba(163, 174, 208, 0.3); border-radius: 10px; }
        .dark .custom-modal-scroll::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.1); }
      `}</style>
        </div>
    );
};

export default StaffAddModal;